export default {
  loading: false,
  error: null,
  data: {
    byUser: [],
    total: {
      totalTokens: 0,
      transactionCount: 0,
    },
  },
  balance: {
    available: 0,
    credits: 0,
    monthly: 0,
    freeMonthly: 0,
    renewDate: null,
    usedThisMonth: 0,
  },
  filters: {
    startDate: null,
    endDate: null,
  },
};

